export function generateTestIdCoreString(path: string) {
  const coreString = path
    .match(/(organisms|molecules|pages|quarks|atoms|templates)\/\w+\/\w+/)?.[0]
    .replaceAll('/', '-');
  return coreString;
}
